import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import {
  closeFormModal,
  openViewModal,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.reducer";
import { useEffect, useState } from "react";
import {
  createFraseSeleccionAplicacionPlantelThunk,
  updateFraseSeleccionAplicacionPlantelThunk,
  getFrasesSeleccionAplicacionPlantelThunk,
  getFraseSeleccionAplicacionPlantelByIdThunk,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.thunks";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const FraseSeleccionAplicacionFormModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const {
    formModalOpen,
    formMode,
    selectedFrase,
    formLoading,
    formError,
    page,
    search,
  } = useSelector((state) => state.frasesSeleccionAplicacionPlantel);

  const [formData, setFormData] = useState({ frase: "" });

  useEffect(() => {
    if (formMode === "edit" && selectedFrase) {
      setFormData({ frase: selectedFrase.frase || "" });
    } else if (formMode === "create") {
      setFormData({ frase: "" });
    }
  }, [formMode, selectedFrase, formModalOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formMode === "create") {
      const result = await dispatch(
        createFraseSeleccionAplicacionPlantelThunk({
          plantel: Number(plantelId),
          frase: formData.frase,
        }),
      );
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(
          getFrasesSeleccionAplicacionPlantelThunk({ plantelId, page, search }),
        );
        toast.success("Frase creada exitosamente");
      }
      return;
    }

    const result = await dispatch(
      updateFraseSeleccionAplicacionPlantelThunk({
        id: selectedFrase.id,
        payload: formData,
      }),
    );
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(
        getFrasesSeleccionAplicacionPlantelThunk({ plantelId, page, search }),
      );
      toast.success("Frase actualizada exitosamente");
      await dispatch(
        getFraseSeleccionAplicacionPlantelByIdThunk(selectedFrase.id),
      );
      dispatch(openViewModal());
    }
  };

  const modalTitle = formMode === "create" ? "Nueva frase" : "Editar frase";
  const submitLabel = formMode === "create" ? "Crear frase" : "Guardar cambios";
  const loadingLabel =
    formMode === "create" ? "Creando frase..." : "Actualizando frase...";

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title={modalTitle}
      size="lg"
    >
      {formLoading ? (
        <Loader center type="dots" text={loadingLabel} />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}
          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              value={formData.frase}
              onChange={(e) => setFormData({ frase: e.target.value })}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {submitLabel}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default FraseSeleccionAplicacionFormModalPlantel;
